<div class="video-tab">
  <div class="video-tab__fields">
    <outlaw-floating-input [control]="form().controls.title" label="Title" />
    <outlaw-floating-textarea [control]="form().controls.description" label="Description" />

    @if (state.videoUploadStatus() === 'idle') {
      <div
        class="video-tab__drop-zone"
        role="button"
        tabindex="0"
        outlawDragAndDrop
        [allowedTypes]="['video/*']"
        (fileDropped)="onFileDrop($event)"
        (click)="onDropZoneClick()"
        (keydown.enter)="onDropZoneClick()"
        (keydown.space)="onDropZoneClick()"
      >
        <outlaw-icon name="dragAndDrop" [size]="24" />
        <span class="video-tab__drop-zone-text">Drag & Drop your video here</span>
      </div>
    }

    @if (state.videoUploadStatus() === 'uploading' || state.videoUploadStatus() === 'processing') {
      <div class="video-tab__loader">
        <outlaw-ring-loader text="Loading video..." />
        <button class="video-tab__cancel-btn" (click)="cancelUpload()">Cancel</button>
      </div>
    }

    @if (state.videoUploadStatus() === 'ready' && state.videoStreamUrl()) {
      <div class="video-tab__video-preview" (click)="togglePlay()">
        <app-stream
          #videoStream
          [streamUrl]="state.videoStreamUrl()"
          [controls]="false"
        />
        <button class="video-tab__video-close" aria-label="Remove video" (click)="cancelUpload(); $event.stopPropagation()">
          <outlaw-icon name="close" [size]="14" />
        </button>
        <div
          class="video-tab__video-play"
          [class.playing]="isPlaying()"
        >
          <outlaw-icon name="playTriangle" [size]="20" />
        </div>
        @if (!state.videoThumbnailUrl() && !state.isUploadingThumbnail()) {
          <button class="video-tab__add-thumbnail-btn" (click)="onThumbnailClick()">
            <outlaw-icon name="media" [size]="16" />
            <span>Add thumbnail</span>
          </button>
        }

        @if (state.isUploadingThumbnail()) {
          <div class="video-tab__add-thumbnail-btn">
            <div class="video-tab__spinner video-tab__spinner--small"></div>
            <span>Uploading...</span>
          </div>
        }

        @if (state.videoThumbnailUrl()) {
          <div class="video-tab__thumbnail">
            <img [src]="state.videoThumbnailUrl()" alt="Thumbnail" />
            <button class="video-tab__thumbnail-remove" aria-label="Remove thumbnail" (click)="removeThumbnail()">
              <outlaw-icon name="close" [size]="14" />
            </button>
          </div>
        }

        <input #thumbnailInput type="file" accept="image/*" hidden (change)="onThumbnailSelected($event)" />
      </div>
    }

    @if (state.videoUploadStatus() === 'error') {
      <div class="video-tab__upload-error">
        <span class="video-tab__error-text">Upload failed</span>
        <button class="video-tab__retry-btn community-button primary with-line" (click)="retryUpload()">Retry</button>
      </div>
    }

    <input
      #videoInput
      type="file"
      accept="video/mp4,video/quicktime,video/webm,video/x-msvideo"
      hidden
      (change)="onFileSelected($event)"
    />
  </div>

  <div class="video-tab__toolbar">
    <div class="video-tab__toolbar-left"></div>
    <div class="video-tab__toolbar-right">
      <outlaw-selections-menu
        [selections]="state.allSelections()"
        postUuid="__pending__"
        mode="inline"
        (selectionToggled)="state.toggleSelection($event)"
        (createClicked)="state.openCreateSelection()"
      >
        <button
          class="video-tab__icon-btn"
          [class.active]="state.selectedSelections().length > 0"
        >
          <outlaw-icon name="grid" [size]="26" />
        </button>
      </outlaw-selections-menu>
      <button
        class="community-button primary with-line"
        [disabled]="!canPublish()"
        (click)="publishRequested.emit()"
      >
        Publish
      </button>
    </div>
  </div>
</div>
